/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Editemail_Templateerror3Inputs */

const en_coinvestments_editemail_templateerror3 = /** @type {(inputs: Coinvestments_Editemail_Templateerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unable to load template from server`)
};

/**
* | output |
* | --- |
* | "Unable to load template from server" |
*
* @param {Coinvestments_Editemail_Templateerror3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editemail_templateerror3 = /** @type {((inputs?: Coinvestments_Editemail_Templateerror3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editemail_Templateerror3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editemail_templateerror3(inputs)
});
export { coinvestments_editemail_templateerror3 as "coInvestments_editEmail_templateError" }